module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp-brk"
  }), _vm._v(" "), _c('p', {
    staticClass: "fmh"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "cfmh"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/title#tit",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Title Page")])])]), _vm._v(" "), _c('p', {
    staticClass: "cfmh"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyn#copyn",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Copyright Notice")])])]), _vm._v(" "), _c('p', {
    staticClass: "cfmh"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/dedication#ded",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Dedication")])])]), _vm._v(" "), _c('p', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/epigraph#epi"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Epigraph")])])]), _vm._v(" "), _c('p', {
    staticClass: "cfmh-bot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/intro#intro"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_vm._v("1:   "), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#ch1"
    }
  }, [_vm._v("Setting the Scene: The Romanov Tercentenary")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_vm._v("2:   "), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter2#ch2"
    }
  }, [_vm._v("The Empress’s Illness, and Her Friend Ania")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_vm._v("3:   "), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter3#ch3"
    }
  }, [_vm._v("Mystical Circles, and the Struggle to Produce an Heir")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_vm._v("4:   "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Autocracy in Crisis")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_vm._v("5:   "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beginnings")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_vm._v("6:   "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("After the Coronation")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_vm._v("7:   "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Family Matters")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_vm._v("8:   "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grigory the Wonder-Worker")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_vm._v("9:   "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Upsets at Home, and the Beginning of War")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_vm._v("10: "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Great Fight")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_vm._v("11: "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From Command to Abdication")])]), _vm._v(" "), _c('p', {
    staticClass: "cct-bot"
  }, [_vm._v("12: "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From Ex’s to Icons")])]), _vm._v(" "), _c('p', {
    staticClass: "cfmh"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "cfmh"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bibliography#bib",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Select Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "cfmh"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index#indx",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "cfmh"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/illustrations#illu",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("List of Illustrations")])])]), _vm._v(" "), _c('p', {
    staticClass: "cfmh"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photographs#photo",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Photographs")])])]), _vm._v(" "), _c('p', {
    staticClass: "cfmh"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/dramatis#drama",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Dramatis Personae")])])]), _vm._v(" "), _c('p', {
    staticClass: "cfmh"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/tree#tree",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Family Tree")])])]), _vm._v(" "), _c('p', {
    staticClass: "cfmh"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/backrgg#rgg",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Discussion Questions")])])]), _vm._v(" "), _c('p', {
    staticClass: "cfmh"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ack#ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "cfmh"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/adcard#adc",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Also by Virginia Rounding")])])]), _vm._v(" "), _c('p', {
    staticClass: "cfmh"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/abouttheauthor#ata",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("About the Author")])])]), _vm._v(" "), _c('p', {
    staticClass: "cfmh"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyright#crp",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Copyright")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef6128c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 69
// module chunks = 0